import { type FC, type ReactNode } from "react";

import { Box, Text } from "@mantine/core";

export interface EmbedErrorPanelProps {
    title: ReactNode;
    message: ReactNode;
    action?: ReactNode;
}

export const EmbedErrorPanel: FC<EmbedErrorPanelProps> = ({ title, message, action }) => (
    <Box p="xl" ta="center">
        <Text size="lg" fw={700}>
            {title}
        </Text>
        <Text c="dimmed" mt="sm">
            {message}
        </Text>
        {action && <Box mt="md">{action}</Box>}
    </Box>
);
